export const environment = {
  production: true,
  api: { baseUrl: 'https://agenda-api.plataformaamais.com' },
  socketIoConfig: {
    url: 'https://agenda-api.plataformaamais.com',
    options: {
      transports: ['websocket'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 100,
    },
  },
  firebase: {
    apiKey: 'AIzaSyC-e2_U0x3lFnA6HqUa7LaVafVgMJByukk',
    authDomain: 'agenda-amais.firebaseapp.com',
    databaseURL: 'https://agenda-amais.firebaseio.com',
    projectId: 'agenda-amais',
    storageBucket: 'agenda-amais.appspot.com',
    messagingSenderId: '597461642731',
    appId: '1:597461642731:web:acbb15b53af234e13f7dae',
  },
  name: 'production',
};
